import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  z-index: 1;
  position: absolute;

  &.selected {
    z-index: 50000;
  }

  &.hover {
    padding-right: 25px;
  }

  > .inner {
    position: absolute;
    box-sizing: border-box;
    padding: 15px;
    background: var(--menu-color);
    cursor: pointer;
    border: 2px solid var(--grey-3);
    border-radius: 4px;
    box-shadow: var(--default-drop-shadow);
    z-index: 1;

    &.selected {
      border: 2px solid var(--primary-cta);
      z-index: 50000;
    }

    .shadow {
      display: flex;
      align-items: center;
      text-align: center;
      position: absolute;
      left: calc(100% + 75px);
      top: 0;
      background: rgba(100, 100, 100, 0.2);
      border: 0 solid transparent;
      border-radius: 4px;
      padding: 15px;
      transition: all;
      line-height: 100%;
      z-index: 20000;

      div {
        color: #888;
        width: 100%;
      }
    }

    &.selected .editable {
      cursor: text;
    }

    .remove {
      position: absolute;
      top: 5px;
      right: 5px;
    }

    .plus {
      display: none;
      position: absolute;
      left: calc(100%);
      top: 50%;
      width: 5em;
      height: 100%;
      background: transparent;
      transform: translateY(-50%);

      > .inner {
        width: 2rem;
        height: 2rem;
        position: absolute;
        top: 50%;
        left: 1.5rem;
        background: var(--primary-cta);
        border: 2px solid var(--primary-cta-active);
        border-radius: 4px;
        color: white;
        line-height: 1.8rem;
        font-size: 1.7rem;
        text-align: center;
        transform: translateY(-50%);
        border-radius: 5px;

        &:hover {
          background-color: var(--primary-cta-light);
        }
      }
    }

    &:hover .plus {
      display: block;
    }

    .plus-image {
      top: 70%;
    }

    .debug {
      position: absolute;
      bottom: 10px;
      right: 10px;
      width: 100px;
      opacity: 0.7;
      font-size: 13px;
      padding: 5px;
      background: white;
    }

    /* Styles for resizable handles */

    .react-resizable {
      position: relative;
    }
    .react-resizable-handle {
      position: absolute;
      width: 30px;
      height: 30px;
      /* background-repeat: no-repeat; */
      /* background-origin: content-box; */
      box-sizing: border-box;
      /* background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+"); */
      /* background-position: bottom right; */
      padding: 0 3px 3px 0;
    }
    .react-resizable-handle-sw {
      bottom: -10px;
      left: -10px;
      cursor: sw-resize;
      transform: rotate(90deg);
    }
    .react-resizable-handle-se {
      bottom: -10px;
      right: -10px;
      cursor: se-resize;
    }
    .react-resizable-handle-nw {
      top: -10px;
      left: -10px;
      cursor: nw-resize;
      transform: rotate(180deg);
    }
    .react-resizable-handle-ne {
      top: -10px;
      right: -10px;
      cursor: ne-resize;
      transform: rotate(270deg);
    }
    .react-resizable-handle-w,
    .react-resizable-handle-e {
      top: 50%;
      margin-top: -10px;
      cursor: ew-resize;
    }
    .react-resizable-handle-w {
      left: 0;
      transform: rotate(135deg);
    }
    .react-resizable-handle-e {
      right: 0;
      transform: rotate(315deg);
    }
    .react-resizable-handle-n,
    .react-resizable-handle-s {
      left: 50%;
      margin-left: -10px;
      cursor: ns-resize;
    }
    .react-resizable-handle-n {
      top: 0;
      transform: rotate(225deg);
    }
    .react-resizable-handle-s {
      bottom: 0;
      transform: rotate(45deg);
    }
  }

  &.naked > .inner {
    border-color: transparent;
    background-color: transparent;
    box-shadow: none;

    &.selected {
      border: 2px solid var(--primary-cta);
    }
  }

  &.is-space-dragging > .inner {
    cursor: grab;
  }
`;
